import { cn } from '@dc-shared-web/lib'

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        'tw-animate-skeleton-shimmer tw-rounded-md tw-bg-muted',
        /* we make the skeleton stretch to fit the parent */
        'tw-h-full tw-w-full',
        className
      )}
      {...props}
    />
  )
}

export { Skeleton }
